import { render, staticRenderFns } from "./edit-contract-info.vue?vue&type=template&id=5972e083&scoped=true&"
import script from "./edit-contract-info.vue?vue&type=script&lang=js&"
export * from "./edit-contract-info.vue?vue&type=script&lang=js&"
import style0 from "./edit-contract-info.vue?vue&type=style&index=0&id=5972e083&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5972e083",
  null
  
)

export default component.exports